import React, { useState, useEffect } from 'react';
import { connect, useDispatch,  } from 'react-redux';
import { Link } from 'react-router-dom';

import { setLightFooter } from '../../app/actions/uiActions';
import PatientDocument from './Document';
import Title from '../../components/Title';
import Button from '../../components/Button';
import { Pluss } from '../../static';
import { s3LoadUrl } from '../../helper/s3LoadUrl';

import './styles.scss';

const PatientDocuments = ({
	currentVirus,
	currentUserId,
	currentVirusDocument
}) => {
	const dispatch = useDispatch();
	const virusName = currentVirus.length && currentVirus[0].name;
	const virusId = currentVirus.length && currentVirus[0].id;
	const [virusDocments, setVirusDocments] = useState([]);

	let bgUrl ='';

	if(currentVirus[0] && currentVirus[0].backgroundImage) {
		bgUrl = s3LoadUrl(currentVirus[0].backgroundImage);
	};

	useEffect(()=> {
		dispatch(setLightFooter(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);

	useEffect(() => {
		currentVirusDocument.virusDocments && 
			currentVirusDocument.virusDocments.length && 
				setVirusDocments(currentVirusDocument.virusDocments)
	}, [currentVirusDocument])


	return (
		<div className="patient-documents">
			<header className="patient-documents__header">
				<Title text={virusName} isExtra isWhite/>
				<div className="patient-documents__btn">
					<Link to={`/virus/${virusId}/add-virus/${currentUserId}`}>
						<Button 
							text='Add New info' 
							type='button' 
							leftIcon={<Pluss />} 
							isLight
						/>
					</Link>
				</div>
				<div className="patient-documents__bg">
					<img src={bgUrl} alt="backgrund_virus"/>
				</div>
			</header>
			<div className="container">
				<section className="patient-documents__content">
					{virusDocments.map((document,i) => (
						<PatientDocument document={document} key={i}/>
					))}
				</section>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const patientViruses =  state.app.patientViruses;
	const dependentsViruses =  state.app.dependentsViruses;

	const currentUserId = ownProps.match.params.id;
	const currentVirusId = ownProps.match.params.idVirus;
	const viruses = state.firestore.ordered.available_viruses;

	let currentVirusDocument = {}

	if(patientViruses.length && patientViruses[0].parentId === currentUserId) {
	
		currentVirusDocument = patientViruses[0].dependentDocuments[currentVirusId];
	} else {
		const currentUaer = dependentsViruses.filter(depPatient => depPatient.patientId === currentUserId)

		currentVirusDocument = currentUaer[0].dependentDocuments[currentVirusId];
	}

	const currentVirus = viruses ? viruses.filter((virus) => virus.id.includes(currentVirusId)) : [];

	return {
		currentVirus,
		currentUserId,
		currentVirusDocument
	};
};

export default connect(mapStateToProps)(PatientDocuments);
